import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import {ModalService} from "../../../aplicaciones-modulos/horas-extras/services/modal.service";

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LfsaModalComponent),
  multi: true
};

@Component({
  selector: 'app-lfsa-modal',
  templateUrl: './lfsa-modal.component.html',
  styleUrls: ['./lfsa-modal.component.css'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR]
})
export class LfsaModalComponent implements OnInit {

  // @ViewChild('abrir', {static: false}) abrir: ElementRef;
  // @ViewChild('modal') modal:ElementRef
  @Input() innTemplate: TemplateRef<any>;
  @Input() titulo = 'Sin titulo';
  @Input() idButton: string;
  @Input() idOpen: string;
  @Input() idClose: string;
  @Input() classModal: string = 'modal-lg'
  @ViewChild('closebutton') closebutton;
  @ViewChild('modalComponent') modalComponent: ElementRef;

  @Output()
  onClose = new EventEmitter<null>();

  constructor( private _modalService: ModalService) { }

  ngOnInit() {
    //this.modalComponent.nativeElement.
    this._modalService.getModalEvent().subscribe(data=> {
      console.log(data);
      if(data && data.action && data.action === 'close'){
        this.close();
      }
    });

  }

  // open() {
  //   // this.abrir.nativeElement.click();
  //   // this.abrir.nativeElement.style.display = 'block';
  //   document.getElementById('abrir').click();
  // }
  emitClose() {
    this.onClose.emit();
  }

  close(){
    this.closebutton.nativeElement.click();
  }
}
